import React from "react"
import { Button } from "primereact/button"
import { Dialog } from 'primereact/dialog'
import { IoIosCheckmarkCircle } from 'react-icons/io'

import './sucesso.css'

export default function DialogSuccess({ openDialog, setOpenDialog, messageHeader, messageBody }) {
  const close = () => {
    window.location.reload()
  }

  const footer = (
    <div>
      <Button label="Ok" icon="pi pi-check" onClick={close} />
    </div>
  );


  return (
    <Dialog header={messageHeader} footer={footer} visible={openDialog} style={{ width: '50vw' }} modal={true} onHide={close}>
      <div className="dialog-content">
        <IoIosCheckmarkCircle color="green" fontSize={50} />
        <h1>{messageBody}</h1>
      </div>
    </Dialog>
  )
}